import lod_ from "lodash";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { Icon } from "@mui/material";
import { LittleForm } from "components/Custom/LittleForm";

/**
 * Analyse component to display the analysis of a conversation.
 * @param {Object} conversation - The conversation object containing analysis data.
 * @param {Object} resource - The resource configuration.
 * @param {Object} dictionary - The dictionary data for the conversation.
 * @param {Object} dictionarySkeleton - The skeleton structure for the dictionary.
 * @return {JSX.Element} The rendered Analyse component.
 */
const Analyse = ({ conversation, resource, dictionary, dictionarySkeleton }) => {
	const hasData = !lod_.isEmpty(dictionary) && !lod_.isEmpty(dictionarySkeleton);

	if (hasData !== true) {
		return (
			<MDBox
				display="flex"
				flexDirection="column"
				alignItems="center"
				justifyContent="center"
				sx={{ py: 8 }}
			>
				<Icon sx={{ fontSize: "48px !important", color: "#ccc", mb: 1 }}>analytics</Icon>
				<MDTypography variant="body2" color="secondary">
					Aucune analyse disponible
				</MDTypography>
			</MDBox>
		);
	}

	return (
		<MDBox
			sx={{
				px: 1,
				py: 1.5,
				overflowY: "auto",
				flex: 1,
				"&::-webkit-scrollbar": { width: 6 },
				"&::-webkit-scrollbar-thumb": {
					backgroundColor: "#ccc",
					borderRadius: 3
				}
			}}
		>
			<LittleForm
				disabled
				object={dictionary?.items}
				metadatasSkeleton={dictionarySkeleton}
				handleChange={(path, value) => {}}
			/>
		</MDBox>
	);
};

export default Analyse;
